import api from 'dao/providers/axios';
import appconfig from 'config/appconfig';

const devicesEndpoint = appconfig.endpoints.devices;

export const daoDevicesGet = (cid) => api.get(`${devicesEndpoint}?cid=${cid}`);
export const daoApproveDevice = (token) => api.put(`${devicesEndpoint}/${token}/approve`);
export const daoReportDevice = (token) => api.put(`${devicesEndpoint}/${token}/report`);
